


const getStrokes = (props)=>{
    const strokeColor = props?.stroke ?? 'rgba(13, 42, 76, 0.5)'
    return {
        normal: {
            stroke: props?.dotted ? {
                dash: '2 2',
                color: strokeColor
            } : `${props?.thickness??1} ${strokeColor}`,

        },
        selected: {
            stroke: `4 ${strokeColor}`
        }
    }
}


const getFills = (props)=> {
    const fillColor = props?.fill ?? 'rgba(0, 0, 0, 0.3)';
    const selectedFillColor = props?.selectedFill ?? 'rgba(0, 0, 0, 0.5)';
    return {
        normal: {
            fill: fillColor
        },
        selected: {
            fill: selectedFillColor
        }
    }
}

const useAnnotations = ({controller})=>{





    const handleAnnotationSettings = (annotation, props)=>{
        annotation.allowEdit(props?.allowEdit??true)
        return annotation
    }


    const setVerticalLine = ({date, ...props})=> {
        const vline = controller.current.verticalLine({
            xAnchor: date,
            ...getStrokes(props)
        });
        return handleAnnotationSettings(vline, props)
    }


    const setVerticalRange = ({dates, ...props})=>{
        const vrange = controller.current.verticalRange({
            xAnchor: dates[0],
            secondXAnchor: dates[1],
            ...getFills(props)
        });
        return handleAnnotationSettings(vrange, props)
    }

    const drawLineSegment = ({x1, x2, y1, y2})=>{
        controller.current.line({
            xAnchor: x1,
            valueAnchor: y1,
            secondXAnchor: x2,
            secondValueAnchor: y2
        });
    }


    return {
        setVerticalLine,
        setVerticalRange,
        drawLineSegment
    }
}

export default useAnnotations;